import * as React from 'react'
import { Card, Result } from 'antd'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import ViewInvoice from './ViewInvoice'
import SelectPayment from './SelectPayment'
import { Switch, Route } from 'react-router'
import CheckPayment from './CheckPayment'
import { useCurrentInvoice } from './queries'
import DirectPayment from './DirectPayment'

const PaymentContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${props => props.theme.paddingUnit * 3}px;
  height: 100%;
`

const InvoiceCard = styled(Card)`
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 500px;
  max-height: 800px;
  height: 100%;
  & .ant-card-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
`

const Payment = () => {
  const { data: invoice, isLoading, isError } = useCurrentInvoice()
  const [state, setState] = React.useState<'view' | 'select' | 'direct'>('view')

  return (
    <PaymentContent>
      <InvoiceCard
        title={
          <FormattedMessage
            id="paymentHeader"
            values={{ reference: invoice?.reference }}
          />
        }
        loading={isLoading}
      >
        <Switch>
          <Route path="/payment/:invoiceID/complete">
            <CheckPayment />
          </Route>
          <Route path="/payment/:invoiceID">
            {isError ? (
              <Result
                status="error"
                title={<FormattedMessage id="error" />}
                subTitle={<FormattedMessage id="paymentError" />}
              />
            ) : state === 'view' ? (
              <ViewInvoice next={() => setState('select')} />
            ) : state === 'select' ? (
              <SelectPayment next={() => setState('direct')} />
            ) : (
              <DirectPayment back={() => setState('select')} />
            )}
          </Route>
        </Switch>
      </InvoiceCard>
    </PaymentContent>
  )
}

export default Payment
